import React, { useState, useEffect } from 'react';
import { Agriculture } from '@mui/icons-material';
// import api from '../../services/api'; // importação não usada

interface Fazenda {
  uid_unidade_producao: string;
  nome: string;
}

/**
 * FazendaSelector
 * 
 * Exibe o nome da fazenda atual no Header.
 * Se o usuário tiver mais de uma fazenda, mostra um select para trocar.
 * Ao trocar, atualiza o localStorage e recarrega os dados da página.
 */
const FazendaSelector: React.FC = () => {
  const [fazendas, setFazendas] = useState<Fazenda[]>([]);
  const [fazendaAtual, setFazendaAtual] = useState<string>('');
  const [nomeFazendaAtual, setNomeFazendaAtual] = useState<string>('');

  useEffect(() => {
    // Lê fazendas do JWT armazenado
    const token = localStorage.getItem('inteagro_token');
    if (!token) return;

    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const lista: Fazenda[] = payload.fazendas || [];
      const atual = localStorage.getItem('uid_unidade_producao') || payload.uid_unidade_producao || '';

      setFazendas(lista);
      setFazendaAtual(atual);

      const fazObj = lista.find(f => f.uid_unidade_producao === atual);
      setNomeFazendaAtual(fazObj?.nome || 'Minha Fazenda');
    } catch {
      // token inválido
    }
  }, []);

  const handleTrocarFazenda = (uid: string) => {
    const fazObj = fazendas.find(f => f.uid_unidade_producao === uid);
    setFazendaAtual(uid);
    setNomeFazendaAtual(fazObj?.nome || '');

    // Atualiza localStorage
    localStorage.setItem('uid_unidade_producao', uid);

    // Recarrega a página para que todos os componentes busquem os novos dados
    window.location.reload();
  };

  // Se só tem uma fazenda, mostra apenas o nome
  if (fazendas.length <= 1) {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', gap: 6,
        padding: '6px 12px', background: '#f0fff8', borderRadius: 8,
        fontSize: '0.85rem', fontWeight: 600, color: '#00b37e',
      }}>
        <Agriculture style={{ fontSize: 16 }} />
        {nomeFazendaAtual || 'Minha Fazenda'}
      </div>
    );
  }

  // Se tem múltiplas fazendas, mostra select
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
      <Agriculture style={{ fontSize: 16, color: '#00b37e' }} />
      <select
        value={fazendaAtual}
        onChange={e => handleTrocarFazenda(e.target.value)}
        style={{
          padding: '6px 10px', borderRadius: 8,
          border: '1px solid #00b37e', outline: 'none',
          fontSize: '0.85rem', fontWeight: 600, color: '#00b37e',
          background: '#f0fff8', cursor: 'pointer',
        }}
      >
        {fazendas.map(f => (
          <option key={f.uid_unidade_producao} value={f.uid_unidade_producao}>
            {f.nome}
          </option>
        ))}
      </select>
    </div>
  );
};

export default FazendaSelector;
